import React, { useEffect, useMemo, useState } from "react";
import { SelectAsyncOptionType } from "react-select/async";
import { SmSelectAsyncSearchBox } from "../../../controls/components/selectAsyncSearchBox/SelectAsyncSearchBox";
import { AdminPartnerSearchItem, ListPartnerSearchAdmin } from "../../../../services/UserService";

export function AdminFilterStoreControl(props: {
	filterStaffId?: number | string;
	selectedLabel?: string;
	/** Bật ở ô LỌC đơn để thấy cả station đã tắt / đã ngừng hợp tác. Ô tạo đơn KHÔNG bật. */
	includeInactive?: boolean;
	doChangeStaffId?: (value: any) => void;
}) {
	const [selectedId, setSelectedId] = useState<string | number>(props.filterStaffId || "");
	const selectedOption = useMemo(
		() =>
			props.filterStaffId && props.selectedLabel
				? {
						value: props.filterStaffId?.toString?.() || "",
						label: props.selectedLabel,
						object: "",
				  }
				: null,
		[props.filterStaffId, props.selectedLabel]
	);

	useEffect(() => {
		setSelectedId(props.filterStaffId || "");
	}, [props.filterStaffId]);

	const loadStaffList = async (input: string, setOpts: (val: SelectAsyncOptionType[]) => void) => {
		try {
			const data = await ListPartnerSearchAdmin(input, props.includeInactive);
			const res = data;
			if (res) {
				// KHÔNG lọc lại theo nhãn ở đây nữa. Server đã tìm theo cả tên nội bộ lẫn tên
				// công khai; bộ lọc cũ so chữ đã gõ với nhãn hiển thị, nên từ khi endpoint đổi
				// sang trả tên công khai (08/2026) thì gõ tên khách sạn ra danh sách RỖNG.
				const selectOpts = convertToSelectOptions(res);
				const clearOption = { label: "Tất cả", value: "", object: "" };
				const mergedOptions = [clearOption, ...selectOpts];
				if (selectedOption && !mergedOptions.find((option) => option.value === selectedOption.value)) {
					mergedOptions.unshift(selectedOption);
				}
				setOpts?.(mergedOptions);
				return mergedOptions;
			}
		} catch (err) {
			console.error(err);
		}

		setOpts([]);
		return;
	};

	// useEffect(() => {
	// 	if (props.filterStaffId) setSelectedId(props.filterStaffId);
	// }, [props.filterStaffId]);

	return (
		<SmSelectAsyncSearchBox
			selectedId={selectedId}
			defaultSelectedOption={selectedOption || undefined}
			onChange={(value: any) => {
				setSelectedId(value);
				props.doChangeStaffId?.(value);
			}}
			loadOptionPromise={loadStaffList}
		/>
	);
}

/**
 * Nhãn hiện trong ô chọn: "Tên khách sạn thật · Tên khách nhìn thấy", kèm ghi chú nếu
 * station đã tắt hoặc đã ngừng hợp tác — đơn cũ của họ vẫn cần lọc được.
 */
export function convertToSelectOptions(data: AdminPartnerSearchItem[]) {
	return data.map((item) => {
		const internalName = item.name || "";
		const publicName = item.displayName || "";
		const names = publicName && publicName !== internalName ? `${internalName} · ${publicName}` : internalName;
		const state = item.isBanned ? " (đã ngừng hợp tác)" : item.active === false ? " (đang tắt)" : "";

		return {
			value: item.id?.toString?.() || "",
			label: `${names}${state}`,
			object: "",
		};
	});
}
